/* eslint-disable */ 
jQuery('.Header-iconMenu').on('click', () => {
  jQuery('body').toggleClass('lock');
  jQuery('.Header-menuWrap').toggleClass('Header-menuWrap-isActive');
});

jQuery('.MenuHeader li').each(function() {
  if ( jQuery(this).children('ul').size() > 0 ) {
      jQuery(this).prepend('<span class="arrowMenu"></span>');
  }           
});

jQuery('.arrowMenu').click(function() {
  var parentContainer = jQuery(this).parents('.menu-item-has-children');
  jQuery('.menu-item-has-children').not(parentContainer).removeClass('menu-item-has-children-isActive');
  parentContainer.toggleClass("menu-item-has-children-isActive");
});